module.exports = __webpack_public_path__ + "assets/61.jpg?b2fce1543a6073a92e7c43755760ec91";